module.exports = __webpack_public_path__ + "img/checklist.6d034713.png";